import qc from 'qc'
import { getLayoutStyleBySize } from '@ps/store/workbench/common/node-utils'
import { executeAction, getPasteNodeLayoutStyleAction } from '@ps/workbench/undo-redo'
import { LayoutStyle } from '@ps/workbench/copy-paste/types'
import { isAudio, isDragonBoneChild, isScene } from '@ps/bridge/qc/base'
import { getNodeStyle } from '@ps/bridge/qc/node'

const layoutAttrs = ['width', 'height', 'x', 'y', 'scaleX', 'scaleY']

export function layoutCanBeCopiedAndPasted(node: qc.Node): boolean {
  return !isAudio(node) && !isScene(node) && !isDragonBoneChild(node)
}

export function layoutCanBePasted(
  targetNodes: qc.Node[],
  originalNode: qc.Node
): boolean {
  return (
    targetNodes.every(node => layoutCanBeCopiedAndPasted(node)) &&
    layoutCanBeCopiedAndPasted(originalNode)
  )
}

export function getLayout(node: qc.Node): LayoutStyle | null {
  return getNodeStyle({
    node: node,
    attrs: layoutAttrs
  }) as LayoutStyle
}

export type PasteLayoutParams = {
  targetNodes: qc.Node[];
  record: boolean;
  style: LayoutStyle;
  originalNode: qc.Node;
};

export function pasteLayout({
  targetNodes,
  record = true,
  style,
  originalNode
}: PasteLayoutParams) {
  if (!targetNodes) return

  const oldStyles: {
    [key: string]: Record<string, any>;
  } = {}
  const styles: {
    [key: string]: Record<string, any>;
  } = {}
  // 如果有后代节点，宽、高x、y的变化需要影响其后代节点
  targetNodes.forEach(node => {
    const data = getLayoutStyleBySize(node, {
      width: style.width,
      height: style.height,
      x: style.x,
      y: style.y,
      scaleX: style.scaleX,
      scaleY: style.scaleY
    })
    const newStyle = data.style
    const oldStyle = data.oldStyle
    styles[node.uuid] = newStyle
    oldStyles[node.uuid] = oldStyle
  })

  // 先计算出当前节点以及其后代节点的新样式与旧样式
  executeAction({
    action: getPasteNodeLayoutStyleAction({
      newValue: {
        styles,
        oldStyles,
        nodes: targetNodes
      },
      oldValue: {
        // 可粘贴给多个节点
        styles: oldStyles,
        nodes: targetNodes
      }
    }),
    record
  })
}
